import { TaskTimeLogModel } from "@jugl-web/rest-api/tasks/models/TaskTimeLog/TaskTimeLogModel";
import { cx, useAppVariant, useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { TimeTrackingHistoryProps } from "../../types";
import { HistoryListItem } from "../HistoryListItem";

interface HistoryListProps {
  timeLogs: TaskTimeLogModel[];
  onShowAll: () => void;
  onEditTimeLog?: TimeTrackingHistoryProps["onEditTimeLog"];
  onDeleteTimeLog?: TimeTrackingHistoryProps["onDeleteTimeLog"];
}

export const HistoryList: FC<HistoryListProps> = ({
  timeLogs,
  onShowAll,
  onEditTimeLog,
  onDeleteTimeLog,
}) => {
  const { t } = useTranslations();

  const { isMobile } = useAppVariant();

  return (
    <div className={cx("flex w-full flex-col", isMobile && "gap-3")}>
      {timeLogs.map((timeLog) => (
        <HistoryListItem
          key={timeLog.id}
          timeLog={timeLog}
          onEditTimeLog={onEditTimeLog}
          onDeleteTimeLog={onDeleteTimeLog}
        />
      ))}
      {timeLogs.length === 0 && (
        <span className="px-2 pt-2 font-secondary text-xs tracking-[0.14px] text-dark-500">
          {t({
            id: "tasks-page.no-logs-yet",
            defaultMessage: "You don't have time logs for this task yet 👀",
          })}
        </span>
      )}
      <button
        type="button"
        onClick={onShowAll}
        className="jugl__focusable-outline tracking=[0.14px] my-1 cursor-pointer self-start border-none bg-transparent px-0 px-2 font-secondary text-sm font-medium text-primary underline transition-colors hover:text-primary-800"
      >
        {t({
          id: "tasks-page.see-all-logs",
          defaultMessage: "See all logs",
        })}
      </button>
    </div>
  );
};
